import View from './view';

export const USCInfo = View;
